import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { ResponseModel,GenericApiResponseModel } from "@model/api.model";
import { TokenService } from '@services/rest/token.service';

@Injectable({
    providedIn: "root",
})
export class StatisticApiService {


    constructor(
        private http: HttpClient,
        private tokenService: TokenService,
        ) {
    }

    getSummary(): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/statistic/summary', ''
        );
    }

}
